import "./index.scss";
import { activateEnquiry } from "./enquiry";

const images = [
  "slideimg2.jpg",
  "slideimg3.jpg",
  "slideimg4.jpg",
  "slideimg5.jpg",
  "slideimg6.jpg",
  "slideimg7.jpg",
  "slideimg8.jpg",
  "slideimg9.jpg",
  "slideimg10.jpg",
];
let currentIndex = 0;
const slideElement = document.querySelector(".slide");
const dotsContainer = document.querySelector(".dots-container");
const alllinks = document.querySelectorAll("a:link");
const sectionnavmob = document.querySelector(".section-navmob");
const open = document.querySelector(".bar"); //close-btn
const close = document.querySelector(".close-btn");
const year1 = document.querySelector("#years47");
const year2 = document.querySelector("#years812");
const pdfPopup = document.getElementById("pdfPopup");
const closeBtn = document.getElementById("closeBtn");
const closeBtn2 = document.getElementById("closeBtn2");
const pdfViewer = document.getElementById("pdfViewer");
const alllink = document.querySelectorAll(".nav-link");

let contact_name = null;
let contact_mobile = null;
let contact_email = null;
contact_name = document.getElementById("name");
contact_mobile = document.getElementById("mobile");
contact_email = document.getElementById("email");
document.querySelector('body').style.display='block'
window.addEventListener("click", function (e) {
  document.querySelectorAll(".warning-box").forEach((box) => box.remove());
});
var UID;
function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

// Get the "source" parameter from the URL
const source = getQueryParam("source") || "source";
var mykeyVals = { source: source };
var saveData = $.ajax({
    type: 'POST',
    url: 'https://newsfeedsmartapp.com/SummerCamp/api/createUser.php',
    data: mykeyVals,
    dataType: "json",
    success: function(resultData) {
      UID=resultData.uid

    },
    // error: function(err) { console.log(err) }
});
// smooth scrolling
alllinks.forEach(function (link) {
  link.addEventListener("click", function (e) {
    const href = link.getAttribute("href");
    window.location.href='https://playoclockkids.com/'
    // if (href === "#")
    //   window.scrollTo({
    //     top: 0,
    //     behavior: "smooth",
    //   });

    // if (href !== "#" && href.startsWith("#")) {
    //   e.preventDefault();
    //   const sectionEl = document.querySelector(href);
    //   sectionEl.scrollIntoView({ behavior: "smooth" });
    // }
  });
});

alllink.forEach(function (link) {
  link.addEventListener("click", function (e) {
    e.preventDefault();
    sectionnavmob.classList.toggle("nav-open");
  });
});

function nextSlide() {
  currentIndex = (currentIndex + 1) % images.length;
  updateSlide();
}
function prevSlide() {
  currentIndex = (currentIndex - 1 + images.length) % images.length;
  updateSlide();
}
function updateSlide() {
  slideElement.style.opacity = 0;
  setTimeout(() => {
    slideElement.src = `Images/${images[currentIndex]}`;
    slideElement.style.opacity = 1;
    updateDots();
  }, 100);
}
function updateDots() {
  const dots = document.querySelectorAll(".dot");
  dots.forEach((dot) => dot.classList.remove("active"));
  dots[currentIndex].classList.add("active");
}
// function createDots() {
//   images.forEach((_, index) => {
//     const dot = document.createElement("div");
//     dot.classList.add("dot");
//     dot.addEventListener("click", () => {
//       currentIndex = index;
//       updateSlide();
//     });
//     dotsContainer.appendChild(dot);
//   });
// }
// setInterval(nextSlide, 3000);
// createDots();
// updateDots();

//mobile-navigation
open.addEventListener("click", function (e) {
  e.preventDefault();
  sectionnavmob.classList.toggle("nav-open");
});
close.addEventListener("click", function (e) {
  e.preventDefault();
  sectionnavmob.classList.toggle("nav-open");
});
year1.addEventListener("mouseover", function () {
  year1.querySelector('img').src = "Images/Button01Roll.png";
});

year1.addEventListener("mouseout", function () {
  year1.querySelector('img').src = "Images/Button01.png"; // Change back to the original image
});

year2.addEventListener("mouseover", function () {
  year2.querySelector('img').src = "Images/Button02Roll.png";
});

year2.addEventListener("mouseout", function () {
  year2.querySelector('img').src = "Images/Button02.png"; // Change back to the original image
});
// activateEnquiry("PlayOClock");





const image = [];
for (let i = 1; i <= 8; i++) {
    image.push(`Images/summerCamp47${i}.png`);
}

const container = document.getElementById("imageContainer");

// Add images to the container
image.forEach(src => {
    const img = document.createElement("img");
    img.src = src;
    container.appendChild(img);
});

const image2 = [];
for (let i = 1; i <= 8; i++) {
    image2.push(`Images/summerCamp812${i}.png`);
}

const container2 = document.getElementById("imageContainer2");

// Add images to the container
image2.forEach(src => {
    const img = document.createElement("img");
    img.src = src;
    container2.appendChild(img);
});
function openPopup() {
    document.getElementById("imagePopup").style.display = "flex";
}

function closePopup() {
    document.getElementById("imagePopup").style.display = "none";
}


year1.addEventListener("click", function () {
  const pdfUrl = "https://newsfeedsmartapp.com/SummerCamp/Images/summerCamp.pdf";
  let mykeyVals = { saveType: 'year47',uniqID:UID };

  $.ajax({
    type: 'POST',
    url: 'https://newsfeedsmartapp.com/SummerCamp/api/valueUpdator.php',
    data: mykeyVals,
    dataType: "json",
    success: function(resultData) {

    },
    // error: function(err) { console.log(err) }
});
  // Check if the browser can display PDFs
  document.getElementById("imagePopup").style.display = "flex";

});

year2.addEventListener("click", function () {
  const pdfUrl = "https://newsfeedsmartapp.com/SummerCamp/Images/summerCamp812.pdf";
  let mykeyVals = { saveType: 'year812',uniqID:UID };

  $.ajax({
    type: 'POST',
    url: 'https://newsfeedsmartapp.com/SummerCamp/api/valueUpdator.php',
    data: mykeyVals,
    dataType: "json",
    success: function(resultData) {

    },
    // error: function(err) { console.log(err) }
});
  // Check if the browser can display PDFs
  document.getElementById("imagePopup2").style.display = "flex";

});

closeBtn.addEventListener("click", function () {
  document.getElementById("imagePopup").style.display = "none";
  document.getElementById("imagePopup2").style.display = "none";

});
closeBtn2.addEventListener("click", function () {
  document.getElementById("imagePopup2").style.display = "none";

});
function mymap() {
  window.open("https://maps.app.goo.gl/2ykojmsBRgwoF7pn8");
}
function myrrs() {
  window.open("https://www.w3schools.com");
}
function myccc() {
  window.open("https://www.w3schools.com");
}




